import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-arrow-up\">\r\n<style type=\"text/css\">\r\n\t#icon-arrow-up .st0{opacity:0.8;enable-background:new    ;}\r\n</style>\r\n<title>资源 115</title>\r\n<g id=\"icon-arrow-up_图层_2_1_\">\r\n\t<g id=\"icon-arrow-up_图层_1-2\">\r\n\t\t<path class=\"st0\" d=\"M20,10c0-5.5-4.5-10-10-10S0,4.5,0,10s4.5,10,10,10S20,15.5,20,10z M13.4,11.7c-0.4,0.4-0.9,0.4-1.3,0\r\n\t\t\tc0,0,0,0,0,0L10,9.6l-2.1,2.1c-0.4,0.4-0.9,0.4-1.3,0c0,0,0,0,0,0c-0.4-0.3-0.4-0.9,0-1.3c0,0,0,0,0,0l2.7-2.7\r\n\t\t\tc0.3-0.4,0.9-0.4,1.3,0c0,0,0,0,0,0l2.7,2.7C13.7,10.8,13.8,11.3,13.4,11.7C13.4,11.7,13.4,11.7,13.4,11.7z\" />\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-up.svg
// module id = P3Ow
// module chunks = 72